import * as React from 'react';
import styled from 'styled-components';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { Label } from '../../typography';

type Props = StyledSystemProps & {
  bg?: string;
  name?: string;
  type?: string;
  color?: string;
  width?: string;
  height?: string;
  paddingLeft?: string;
  boxShadow?: string;
  placeholder?: string;
  showEyeIcon?: boolean;
  passwordVisible?: boolean;
  children?: React.ReactNode;
  onTogglePassword?: () => void;
  disabled?: boolean;
  borderRadius?: string | number;
  id?: string;
  onChange?: (e: any) => void;
  autoComplete?: string;
  value?: string;
  min?: number;
  max?: number;
  field: any;
  label: string;
};

const InputWrap = styled.div`
  flex: 1 0 48%;
  margin-bottom: 15px;
  margin-right: 20px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
  @media screen and (min-width: 52em) {
    flex: 1 0 23%;
  }
`;

const StyledImage = styled.img`
  padding-left: 10px;
  display: flex;
  position: relative;
  border-style: none;
  box-sizing: border-box;
  max-height: 100px;
  max-width: 150px;
`;

const Signature: React.FC<Props> = (props: Props) => {
  const { field: { value } } = props;
  console.log(props);
  return (
    <InputWrap>
      <Label>{props.label}</Label>
      {value && <StyledImage {...props} src={value} />}
      {!value && <i>No signature provided</i>}
    </InputWrap>
  );
};

export default Signature;

Signature.defaultProps = {
  bg: 'paleGrey',
  field: { value: '' },
  borderRadius: 4,
};



// WEBPACK FOOTER //
// ./src/components/formElements/StyledSignature.tsx